export default function encodeObject(object) {
    return encodeURIComponent(JSON.stringify(object));
}